// This is the session TTL in minutes (matching Cognito or less would make sense)
export const sessionCookieDuration = 60 * 15 + 59; // ~16 hs
